import { PKG } from '../analytics/analyticsConsts';
import { store } from '../app/store';
import { ANALYTICS } from '../firebase/firebase';
import { METHOD, Request } from '../utils/http';
import { URL } from './apiConstants';

export const SetBackendLanguage = async (): Promise<
  [object | null, Error | null]
> => {
  try {
    const language = store.getState().languageSelector.code;
    const token = store.getState().consumerInfoSelector.auth.token;
    const deviceID = store.getState().apiScreenScreenSelector.deviceID;

    const data = await Request({
      url: `${URL.LANGUAGE}`,
      method: METHOD.POST,
      token: token,
      deviceID: deviceID,
      body: {
        Language: language,
      },
    });

    return [data as object, null];
  } catch (error) {
    ANALYTICS.funcError(PKG, 'SetLanguageError', JSON.stringify(error));
    return [null, error as Error];
  }
};
